import React, { useLayoutEffect } from 'react';

import './dopi.css';
import { isMobile } from 'react-device-detect';


const Affi=()=>{
    useLayoutEffect(()=>{
        window.scrollTo(0,0);
    },[]);
    document.title = "제휴·제안 - 돌파공모";

return(
<div className='doll'>
<h3>제휴&제안</h3>
<p>돌파공모로 돌파를 이어갈 제안을 기다립니다!</p>
<p>공모전, 대외활동, 이벤트, 교육 모두 제휴할 수 있습니다.</p>
<h3>메일 문의</h3>
<p>dolpa@dolpagongmo.com</p>
<h3>전화 문의</h3>
<p>010-8634-0876</p>
<p>진행 순서</p>
</div>
);

};

export default Affi;